/* NBN product page test (Option A / B): gallery, colour picker, add to cart, sticky bar, creator videos. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCart() {
    // Theme header bubble + theme drawer listen for this.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var rebuy = window.Rebuy;
    if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
      var p = rebuy.Cart && typeof rebuy.Cart.fetchCart === 'function' ? rebuy.Cart.fetchCart() : null;
      Promise.resolve(p).catch(function () {}).then(function () { rebuy.SmartCart.show(); });
      return;
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function') {
      setTimeout(function () { drawer.open(); }, 350);
      return;
    }
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  }

  function init(root) {
    if (root.dataset.npReady) return;
    root.dataset.npReady = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var data = JSON.parse($('[data-np-variants]').textContent);
    var select = $('select[name="id"]');
    var mainImg = $('.np-main-img img');
    var promo = parseInt(root.dataset.npPromo || '0', 10) || 0;
    var current = data.filter(function (v) { return String(v.id) === select.value; })[0] || data[0];

    var tag = $('.np-tag');
    function setMain(src, btn) {
      if (!src) return;
      mainImg.src = src;
      // The badge would cover the text on the info tiles, so hide it on those.
      if (tag) tag.hidden = !!(btn && btn.hasAttribute('data-tile'));
      mainImg.removeAttribute('srcset');
      $$('.np-thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === btn ? 'true' : 'false'); });
      if (btn && btn.scrollIntoView) {
        var row = btn.parentNode;
        row.scrollTo({ left: btn.offsetLeft - row.offsetLeft - 8, behavior: 'smooth' });
      }
    }
    $$('.np-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () { setMain(b.dataset.src, b); });
    });

    function render() {
      $$('[data-np-colour]').forEach(function (el) { el.textContent = current.title === 'Default Title' ? (root.dataset.npProductTitle || current.title) : current.title; });
      $$('[data-np-price]').forEach(function (el) { el.textContent = money(current.price - promo); });
      $$('[data-np-was]').forEach(function (el) { el.textContent = money(current.price); });
      // Total includes any care-kit add-ons picked (nbn-pdp-kit.js).
      var tot = root._npTotal ? root._npTotal() : current.price - promo;
      $$('[data-np-afterpay]').forEach(function (el) { el.textContent = money(Math.ceil(tot / 4)); });
      // Afterpay's own widget: show instalments on what they'll actually pay.
      $$('square-placement').forEach(function (el) { el.setAttribute('data-amount', (tot / 100).toFixed(2)); });
      $$('[data-np-atc]').forEach(function (b) {
        b.disabled = !current.available;
        var label = b.querySelector('[data-np-atc-label]');
        if (label) label.textContent = current.available ? (b.dataset.label || 'Add to cart') : 'Sold out';
      });
      var sticky = $('[data-np-sticky-name]');
      if (sticky) sticky.textContent = sticky.dataset.prefix + (root.dataset.npProductContent === 'true' && current.title === 'Default Title' ? '' : ' · ' + current.title);
    }

    $$('.np-sw').forEach(function (s) {
      s.addEventListener('click', function () {
        current = data.filter(function (v) { return String(v.id) === s.dataset.id; })[0] || current;
        $$('.np-sw').forEach(function (x) { x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
        select.value = String(current.id);
        Array.prototype.forEach.call(select.options, function (o) {
          if (o.value === select.value) o.setAttribute('selected', 'selected'); else o.removeAttribute('selected');
        });
        select.dispatchEvent(new Event('change', { bubbles: true }));
        var t = $$('.np-thumbs button').filter(function (b) { return b.dataset.variant === String(current.id); })[0];
        setMain(t ? t.dataset.src : s.dataset.src, t);
        render();
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', u.toString());
        }
      });
    });

    var err = $('[data-np-error]');
    function addToCart(btn) {
      if (!current.available) return;
      btn.classList.add('is-loading');
      if (err) err.textContent = '';
      var mainItem = {id:current.id,quantity:1};
      var bundleProperties = root._npBundleProperties ? root._npBundleProperties() : null;
      if (bundleProperties) mainItem.properties = bundleProperties;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [mainItem].concat(root._npExtraItems ? root._npExtraItems() : []) })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { document.dispatchEvent(new CustomEvent('np:added')); openCart(); })
        .catch(function (e) {
          if (err) err.textContent = (e && (e.description || e.message)) || 'Sorry, that didn’t work. Please try again.';
        })
        .then(function () { btn.classList.remove('is-loading'); });
    }
    $$('[data-np-atc]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); });
    });
    var form = $('form[data-np-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart($('#AddToCartNP') || $('[data-np-atc]')); });

    // Keep the mobile action tappable above Shopify's preview toolbar.
    var mainAtc = $('[data-np-main-atc]');
    var bar = $('.np-sticky');
    if (mainAtc && bar) {
      var stickyFrame = 0;
      var watchedToolbar = null;
      var toolbarObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleSticky) : null;
      function updateSticky() {
        stickyFrame = 0;
        var toolbar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
        var offset = 0;
        if (toolbar) {
          var box = toolbar.getBoundingClientRect();
          if (box.width > 0 && box.height > 0 && box.top < window.innerHeight && box.bottom >= window.innerHeight - 2) {
            offset = Math.min(box.height, window.innerHeight - box.top);
          }
          if (toolbarObserver && toolbar !== watchedToolbar) {
            if (watchedToolbar) toolbarObserver.unobserve(watchedToolbar);
            toolbarObserver.observe(toolbar);
            watchedToolbar = toolbar;
          }
        }
        bar.style.setProperty('--np-sticky-toolbar-offset', offset + 'px');
        var show = mainAtc.getBoundingClientRect().bottom <= 0 && window.innerWidth < 900;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        Array.prototype.forEach.call(bar.querySelectorAll('button'), function (button) { button.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('nbn-sticky-atc-visible', show);
      }
      function scheduleSticky() {
        if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateSticky);
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky, { threshold: 0 }).observe(mainAtc);
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky, { passive: true });
      window.addEventListener('pageshow', scheduleSticky);
      if ('MutationObserver' in window) new MutationObserver(scheduleSticky).observe(document.body, { childList: true });
      updateSticky();
    }

    // Option B delivery picker.
    $$('.np-speed button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.np-speed button').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        var msg = $('[data-np-speed-msg]');
        if (msg) msg.textContent = b.dataset.msg;
      });
    });

    // Creator videos: autoplay muted when in view, tap for sound.
    var vids = $$('.np-ugc video');
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.6 });
      vids.forEach(function (v) { vo.observe(v); });
    }
    vids.forEach(function (v) {
      v.addEventListener('click', function () {
        var turnOn = v.muted;
        vids.forEach(function (o) { o.muted = true; o.closest('.np-ugc').classList.remove('playing'); });
        v.muted = !turnOn;
        if (!v.muted) { v.currentTime = 0; v.play(); v.closest('.np-ugc').classList.add('playing'); }
      });
    });

    render();
  }

  function boot() {
    // The store's reserve-in-store widget (nbn-widget.js) only starts when its stock box exists.
    // Option A shows the reserve button only, so the stock box is added but kept hidden.
    if (document.getElementById('nbn-reserve-container') && !document.getElementById('nbn-widget-container')) {
      var box = document.createElement('div');
      box.id = 'nbn-widget-container';
      box.hidden = true;
      document.getElementById('nbn-reserve-container').insertAdjacentElement('afterend', box);
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-np-section]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
